<script setup lang="ts">
const dialogVisible = ref(false)
const props = defineProps<{
  wxGzQrCodeUrl: string
}>()
const cancelButton = () => {
  dialogVisible.value = false
}
const showDialog = () => {
  dialogVisible.value = true
}
defineExpose({
  showDialog,
})
</script>
<template>
  <el-dialog v-model="dialogVisible" width="500px" top="30vh" center @close="cancelButton">
    <div class="flex flex-col items-center justify-center">
      <h2 class="main-title text-center text-themeColor2 text-2xl mb-6">订阅我们</h2>

      <div class="qrcode-container text-center mb-4">
        <img :src="wxGzQrCodeUrl" alt="公众号二维码" class="w-[300px] h-[300px] mx-auto" />
        <p class="text-size14 mt-2 text-center">微信扫描二维码关注公众号</p>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped>
.text-size14 {
  font-size: 14px;
}

.text-size16 {
  font-size: 16px;
}

.main-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
}
</style>
